// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__20or8","productName":"Table_productName__2kUu4"};